import Vue from "vue";
import Axios from "axios";
import store from "../store/index";
import router from "../router";

Vue.prototype.$http = Axios;

Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.prototype.$http.defaults.headers.common["X-Requested-With"] =
  "XMLHttpRequest";
Vue.prototype.$http.defaults.params = {};
const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${token}`;
}

Vue.prototype.$http.interceptors.request.use(config => {
  return config;
});

Vue.prototype.$http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const code = error.response ? error.response.status : null;
    switch (code) {
      case 401:
        store.dispatch("authLogout").then(() => {
          router.push("/");
        });
        break;
      default:
        break;
    }
    return Promise.reject(error);
  }
);
